const togglePassword = document.querySelector('#togglePassword');
const password = document.querySelector('#user_password');


if(togglePassword && password) {

    togglePassword.addEventListener('click', function (e) {
        // passwordのタイプを切り替え
        const type = password.getAttribute('type') === 'password' ? 'text' : 'password';
        password.setAttribute('type', type);

        // アイコンを切り替え
        this.classList.toggle('myfont-password');
    });
}


const togglePassword_confirm = document.querySelector('#togglePassword_confirm');
const password_confirm = document.querySelector('#user_password_confirm');


if(togglePassword_confirm && togglePassword_confirm) {

    togglePassword_confirm.addEventListener('click', function (e) {
        // passwordのタイプを切り替え
        const type = password_confirm.getAttribute('type') === 'password' ? 'text' : 'password';
        password_confirm.setAttribute('type', type);

        // アイコンを切り替え
        this.classList.toggle('myfont-password');
    });
}